import { createRouter, createWebHistory } from "vue-router";
import Carousel from "@/views/Carousel.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import ContactUs from "@/views/ContactUs.vue";
import AboutUs from "@/views/AboutUs.vue";
import Profile from "@/views/ProfileView.vue";
import WebScraper from "@/views/WebScraper.vue";
import Utils from "@/views/Utils.vue";
import Feedback from "@/views/Feedback.vue";
import Tools from "@/views/Tools.vue";
import ArrayView from "@/views/ArrayView.vue";
import LoginView from "@/views/LoginView.vue";
import NotFound from "@/views/NotFound.vue";

import PromptInstruct from "@/views/PromptInstruct.vue";
import Assistant from "@/views/Assistant.vue";
import cmots from "@/views/cmots.vue";
import ChatView from "@/views/ChatView.vue";
import Pricing from "@/views/Pricing.vue";
import KiteConnectApp from "../components/KiteConnectApp";

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Carousel,
  },
  {
    path: "/principles",
    name: "Principles",
    component: () => import("../components/Principles"),
  },
  {
    path: "/fields",
    name: "Fields",
    component: () => import("../utils/Fields"),
  },
  {
    path: "/vocab",
    name: "Vocabulary",
    component: () => import("@/views/Vocabulary.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/info",
    name: "Scraper",
    component: WebScraper,
  },
  {
    path: "/cmots",
    name: "cmots",
    component: cmots,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },

  {
    path: "/assistant",
    name: "Assistant",
    component: Assistant,
  },
  {
    path: "/options",
    name: "Options",
    component: () => import("@/views/OptionsChain.vue"),
  },
  {
    path: "/futures",
    name: "Futures",
    component: () => import("@/views/Futures.vue"),
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: Feedback,
  },
  {
    path: "/share/:uuid",
    name: "ChatView",
    component: ChatView,
  },
  {
    path: "/shareholding",
    name: "Shareholding",
    component: () => import("@/views/ShareholdingByInvestor.vue"),
  },
  {
    path: "/promptInstruct",
    name: "PromptInstruct",
    component: PromptInstruct,
  },
  {
    path: "/dipsip",
    name: "DipSip",
    component: () => import("@/views/DipSip.vue"),
  },
  {
    path: "/livemarkets",
    name: "LiveMarkets",
    component: () => import("@/views/LiveMarkets.vue"),
  },
  {
    path: "/etfList",
    name: "ETFPage",
    component: () => import("@/views/ETFPage.vue"),
  },

  // Trading Agent Routes
  {
    path: "/tradingagent",
    redirect: "/tradingagent/indicators",
    meta: { title: "Trading Agent" },
  },
  {
    path: "/tradingagent/indicators",
    name: "TradingAgentIndicators",
    component: () => import("@/views/TradingAgent.vue"),
    meta: {
      title: "Trading Indicators",
      parent: "Trading Agent",
    },
  },
  {
    path: "/tradingagent/strategies",
    name: "TradingAgentStrategies",
    component: () => import("@/views/TradingAgentStrategies.vue"),
    meta: {
      title: "Trading Strategies",
      parent: "Trading Agent",
    },
  },

  {
    path: "/mutualfunds",
    name: "MutualFunds",
    component: () => import("@/views/MutualFund.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: Pricing,
  },
  {
    path: "/riskProfile",
    name: "RiskProfile",
    component: () => import("@/views/RiskProfile.vue"),
  },
  {
    path: "/utils",
    name: "Utils",
    component: Utils,
  },
  {
    path: "/tools",
    name: "Tools",
    component: Tools,
  },
  {
    path: "/arrayview",
    name: "ArrayView",
    component: ArrayView,
  },
  {
    path: "/company/:symbol",
    name: "CompanyDetails",
    component: () => import("@/views/Company.vue"),
    props: true,
  },
  {
    path: "/watchlist",
    name: "WatchList",
    component: () => import("@/views/WatchList.vue"),
    props: true,
  },
  {
    path: "/indexes",
    name: "Indexes",
    component: () => import("@/views/Indexes.vue"),
    props: true,
  },
  {
    path: "/trade",
    name: "Trade",
    component: KiteConnectApp,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: PrivacyPolicy,
  },
  {
    path: "/about",
    name: "About",
    component: AboutUs,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactUs,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
